import { ADMIN, CONSUMER } from '../../../services/cognito/userGroups'

const ALLOW_ALL = [
  CONSUMER, ADMIN
]

const ALLOW_ALL_NON_ADMIN = [CONSUMER]

export const ALLOW = {
  mobile: {
    menu: {
      home: ALLOW_ALL,
      checklist: ALLOW_ALL_NON_ADMIN,
      mcoach: ALLOW_ALL,
      skillbites: ALLOW_ALL,
      contenthub: ALLOW_ALL,
      playlists: ALLOW_ALL,
      quizzes: ALLOW_ALL,
      bonus: ALLOW_ALL_NON_ADMIN,
      whatsnew: ALLOW_ALL
    }
  },
  tablet: {
    menu: {
      home: ALLOW_ALL,
      checklist: ALLOW_ALL_NON_ADMIN,
      mcoach: ALLOW_ALL,
      skillbites: ALLOW_ALL,
      contenthub: ALLOW_ALL,
      playlists: ALLOW_ALL,
      quizzes: ALLOW_ALL,
      bonus: ALLOW_ALL_NON_ADMIN,
      whatsnew: ALLOW_ALL
    }
  },
  desktop: {
    navmenu: {
      home: ALLOW_ALL,
      checklist: ALLOW_ALL_NON_ADMIN,
      mcoach: ALLOW_ALL,
      skillbites: ALLOW_ALL,
      contenthub: ALLOW_ALL,
      playlists: ALLOW_ALL,
      quizzes: ALLOW_ALL,
      bonus: ALLOW_ALL_NON_ADMIN
    }
  }
}
